export const sendPicsHandleChangeCallback = (setForm, form) => (formValue) => {
  setForm({ ...form, ...formValue });

  return Promise.resolve({});
};
